import {
  loadStoresLoading,
  loadStoresError,
  loadStoresSuccess,
} from "../../reducers/Store/index";

export const getStores = (data) => async (dispatch) => {
  try {
    dispatch(loadStoresLoading());
    dispatch(loadStoresSuccess(data));
  } catch (error) {
    console.error(error);
    dispatch(loadStoresError(data.message || "Unexpected Error!!!"));
  }
};
